export const IN_APP_NOTIFICATIONS_QUERY = {
  RETRIEVE: 'retrieveInAppNotifications',
  NOTICIATIONS_COUNT: 'requestInAppNotificationsCount',
};

export const NOTIFICATIONS_COUNT_PER_PAGE = 12;

export const NOTIFICATIONS_FILTER = {
  All: 'all',
  Unread: 'unread',
} as const;

export type NotificationsFilter =
  (typeof NOTIFICATIONS_FILTER)[keyof typeof NOTIFICATIONS_FILTER];
